import axios from 'axios';

// 프로덕션: 백엔드가 빌드를 직접 서빙하거나 Nginx 가 /api 를 프록시 → 상대 경로
// 개발: CRA(3010) → 백엔드(3011)
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (process.env.NODE_ENV === 'production') return '/api';
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') return `${protocol}//${hostname}:3011/api`;
  }
  return 'http://localhost:3011/api';
};

export const API_URL = getApiUrl();

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Client': 'web',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthCall = /\/auth\/(login|register|check-email|resend-verification|forgot-password|reset-password)/.test(error.config?.url || '');
    if (error.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        if (error.response?.data?.code === 'SESSION_EXPIRED') {
          alert(error.response.data.error || '세션이 만료되었습니다. 다시 로그인해주세요.');
        }
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/** express-validator `{ errors: [{ msg }] }` 및 `{ error }` 공통 추출 */
export const getErrorMessage = (error, fallback = '요청 처리 중 오류가 발생했습니다.') => {
  if (error?.code === 'ERR_NETWORK') return '서버에 연결할 수 없습니다. 인증 서버가 실행 중인지 확인하세요.';
  const data = error?.response?.data;
  const msgs = Array.isArray(data?.errors) ? data.errors.map((e) => e.msg).filter(Boolean) : [];
  if (msgs.length) return msgs.join('\n');
  return data?.error || data?.message || error?.message || fallback;
};

export default apiClient;
